import React from "react"

import { Title5 } from "../../../assets/styles/typographyStyles"

export const Title = () => (
  <Title5 style={{ textAlign: "center" }}>CooWe Make Meetings Happen</Title5>
)
